import Alpine from 'alpinejs';
import { appStore } from '@/stores/app';
import { RecommendedTitle } from './recommended_title';
import { getCookie } from '@/utils/cookie';

const isLoggedIn = appStore.getGlobalData().user.isLoggedIn;
const cdnRoot = appStore.getGlobalData().CDNROOT;

const coe = getCookie('coe');
const coc = getCookie('coc');

Alpine.data('recommendedTitle', () => new RecommendedTitle(isLoggedIn, cdnRoot, coe, coc));
